module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"max_reached":"已達上限"},"en":{"max_reached":"Max reached"}}')
  delete Component.options._Ctor
}
